import { render, staticRenderFns } from "./WhatsAppMessageSettings.vue?vue&type=template&id=2d42c872&scoped=true"
import script from "./WhatsAppMessageSettings.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessageSettings.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppMessageSettings.vue?vue&type=style&index=0&id=2d42c872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d42c872",
  null
  
)

export default component.exports